// src/components/EmailVerifiedRoute.jsx
import React from 'react'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import LoadingSpinner from './LoadingSpinner';

export default function EmailVerifiedRoute() {
  const { currentUser, globalLoading } = useAuth()
  const location = useNavigate()

  if (globalLoading) {
    return <LoadingSpinner />
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (!currentUser.emailVerified) {
    return <Navigate to="/verify-email" state={{ from: location }} replace />
  }

  return <Outlet />
}
